import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Zap, Users, TrendingUp, CheckCircle2, Building2, GraduationCap, Dumbbell, Heart, ArrowRight, Star, Brain, Target, Clock } from "lucide-react";
import tadpoleImage from "@/assets/tadpole.png";
import youngFrogImage from "@/assets/young-frog.png";
import frogImage from "@/assets/frog.png";
import Footer from "@/components/layout/Footer";
import ScrollToTopButton from "@/components/ScrollToTopButton";
const Home = () => {
  return <div className="min-h-screen bg-background">
      <ScrollToTopButton />
      {/* Header */}
      <header className="fixed top-0 left-0 right-0 z-50 bg-background/80 backdrop-blur-lg border-b border-border/50">
        <div className="container mx-auto px-4 py-4 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <span className="text-3xl">🐸</span>
            <span className="font-display font-bold text-xl text-foreground">HabitFrog</span>
          </div>
          <div className="flex items-center gap-3">
            <Button variant="ghost" asChild>
              <Link to="/auth">Entrar</Link>
            </Button>
            <Button variant="coral" asChild>
              <Link to="/auth">Começar Grátis</Link>
            </Button>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="pt-32 pb-20 px-4 relative overflow-hidden">
        <div className="absolute inset-0 bg-pond-gradient opacity-5" />
        <div className="absolute top-20 left-10 text-6xl animate-float opacity-30">🌿</div>
        <div className="absolute top-40 right-20 text-4xl animate-float opacity-20" style={{
        animationDelay: "1s"
      }}>🪷</div>
        <div className="absolute bottom-20 left-1/4 text-5xl animate-float opacity-25" style={{
        animationDelay: "0.5s"
      }}>🐸</div>
        
        <div className="container mx-auto text-center relative z-10">
          
          
          <h1 className="font-display text-4xl md:text-6xl lg:text-7xl font-bold text-foreground mb-6 leading-tight">
            Transforme sua vida,
            <br />
            <span className="text-gradient-sunset">um hábito de cada vez</span>
          </h1>
          
          <p className="text-lg md:text-xl text-muted-foreground max-w-2xl mx-auto mb-8">
            Pare de lutar sozinho contra seus maus hábitos. Crie sapos virtuais que crescem 
            conforme você evolui. Gamificação baseada em ciência para resultados reais.
          </p>
          
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
            <Button size="xl" variant="coral" asChild className="gap-2">
              <Link to="/auth">
                Começar Gratuitamente
                <ArrowRight className="w-5 h-5" />
              </Link>
            </Button>
            <Button size="xl" variant="outline" asChild>
              <a href="#como-funciona">Ver como funciona</a>
            </Button>
          </div>
          
          <div className="flex items-center justify-center gap-8 text-sm text-muted-foreground">
            <div className="flex items-center gap-2">
              <CheckCircle2 className="w-4 h-4 text-primary" />
              <span>Sem cartão de crédito</span>
            </div>
            <div className="flex items-center gap-2">
              <CheckCircle2 className="w-4 h-4 text-primary" />
              <span>Cancele quando quiser</span>
            </div>
            <div className="flex items-center gap-2">
              <CheckCircle2 className="w-4 h-4 text-primary" />
              <span>Pague só pelo sucesso</span>
            </div>
          </div>
        </div>
      </section>

      {/* Technology Section */}
      <section id="como-funciona" className="py-20 px-4 bg-secondary/30">
        <div className="container mx-auto">
          <div className="text-center mb-12">
            <h2 className="font-display text-3xl md:text-4xl font-bold text-foreground mb-4">
              Tecnologia a favor dos seus hábitos
            </h2>
            <p className="text-muted-foreground max-w-xl mx-auto">
              Ferramentas inteligentes para você nunca mais esquecer de cuidar de si mesmo
            </p>
          </div>
          
          <div className="grid md:grid-cols-3 gap-6">
            <div className="pond-card text-center">
              <div className="w-14 h-14 rounded-2xl bg-primary/10 flex items-center justify-center mx-auto mb-4">
                <Clock className="w-7 h-7 text-primary" />
              </div>
              <h3 className="font-display font-bold text-lg mb-2">Lembretes Inteligentes</h3>
              <p className="text-muted-foreground text-sm">
                Notificações personalizadas no momento certo, baseadas no seu padrão de uso
              </p>
            </div>
            
            <div className="pond-card text-center">
              <div className="w-14 h-14 rounded-2xl bg-coral/10 flex items-center justify-center mx-auto mb-4">
                <TrendingUp className="w-7 h-7 text-coral" />
              </div>
              <h3 className="font-display font-bold text-lg mb-2">Tracking Visual</h3>
              <p className="text-muted-foreground text-sm">
                Acompanhe seu progresso com gráficos e estatísticas motivadoras
              </p>
            </div>
            
            <div className="pond-card text-center">
              <div className="w-14 h-14 rounded-2xl bg-golden/10 flex items-center justify-center mx-auto mb-4">
                <Target className="w-7 h-7 text-golden" />
              </div>
              <h3 className="font-display font-bold text-lg mb-2">Metas Flexíveis</h3>
              <p className="text-muted-foreground text-sm">
                Configure frequências diárias, semanais ou mensais conforme sua realidade
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-20 px-4">
        <div className="container mx-auto">
          <div className="text-center mb-12">
            <h2 className="font-display text-3xl md:text-4xl font-bold text-foreground mb-4">
              Tudo que você precisa para criar hábitos duradouros
            </h2>
          </div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {[{
            icon: "🥚",
            title: "Gamificação Real",
            desc: "Cada hábito vira um sapo que evolui de ovo a adulto. Cuide deles para vê-los crescer!"
          }, {
            icon: "📸",
            title: "Evidências",
            desc: "Comprove seus hábitos com fotos, confirmação de amigos ou métricas automáticas"
          }, {
            icon: "🏆",
            title: "Streaks",
            desc: "Mantenha sequências de dias consecutivos e nunca mais quebre a corrente"
          }, {
            icon: "🌍",
            title: "Comunidade",
            desc: "Junte-se a lagoas públicas ou crie a sua própria com amigos e família"
          }, {
            icon: "📊",
            title: "Estatísticas",
            desc: "Visualize sua evolução ao longo do tempo com dashboards completos"
          }, {
            icon: "🔔",
            title: "Notificações",
            desc: "Receba lembretes gentis para nunca esquecer de completar seus hábitos"
          }].map((feature, i) => <div key={i} className="pond-card group hover:scale-105 transition-transform duration-300">
                <div className="text-4xl mb-4">{feature.icon}</div>
                <h3 className="font-display font-bold text-lg mb-2">{feature.title}</h3>
                <p className="text-muted-foreground text-sm">{feature.desc}</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* Ponds Section */}
      <section className="py-20 px-4 bg-pond-gradient text-primary-foreground">
        <div className="container mx-auto">
          <div className="text-center mb-12">
            <h2 className="font-display text-3xl md:text-4xl font-bold mb-4">
              Lagoas para todo tipo de comunidade
            </h2>
            <p className="opacity-80 max-w-xl mx-auto">
              Crie espaços compartilhados para acompanhar hábitos em grupo. 
              Juntos vocês vão mais longe!
            </p>
          </div>
          
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {[{
            icon: <Building2 className="w-6 h-6" />,
            title: "Empresas",
            desc: "Time engajado e saudável"
          }, {
            icon: <Users className="w-6 h-6" />,
            title: "Grupos de Amigos",
            desc: "Desafios entre amigos"
          }, {
            icon: <Dumbbell className="w-6 h-6" />,
            title: "Personal Trainers",
            desc: "Acompanhe seus alunos"
          }, {
            icon: <Heart className="w-6 h-6" />,
            title: "Famílias",
            desc: "Hábitos em família"
          }, {
            icon: <GraduationCap className="w-6 h-6" />,
            title: "Escolas",
            desc: "Educação de hábitos"
          }, {
            icon: <Users className="w-6 h-6" />,
            title: "Clubes",
            desc: "Comunidades engajadas"
          }, {
            icon: <Zap className="w-6 h-6" />,
            title: "Startups",
            desc: "Cultura de alta performance"
          }, {
            icon: <Star className="w-6 h-6" />,
            title: "Coaches",
            desc: "Monitore seus coachees"
          }].map((item, i) => <div key={i} className="bg-primary-foreground/10 backdrop-blur-sm rounded-2xl p-5 text-center hover:bg-primary-foreground/20 transition-colors">
                <div className="w-12 h-12 rounded-full bg-primary-foreground/20 flex items-center justify-center mx-auto mb-3">
                  {item.icon}
                </div>
                <h3 className="font-display font-bold mb-1">{item.title}</h3>
                <p className="text-sm opacity-70">{item.desc}</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* Science Section */}
      <section className="py-20 px-4">
        <div className="container mx-auto">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <div className="inline-flex items-center gap-2 bg-secondary/50 rounded-full px-4 py-2 mb-4">
                <Brain className="w-4 h-4 text-primary" />
                <span className="text-sm font-medium">Baseado em ciência</span>
              </div>
              
              <h2 className="font-display text-3xl md:text-4xl font-bold text-foreground mb-6">
                A ciência por trás da formação de hábitos
              </h2>
              
              <div className="space-y-4 text-muted-foreground">
                <p>
                  Estudos mostram que leva em média <strong className="text-foreground">66 dias</strong> para 
                  formar um novo hábito. Nosso sistema de evolução de sapos foi desenhado 
                  baseado nessa pesquisa da University College London.
                </p>
                <p>
                  A gamificação aumenta em até <strong className="text-foreground">48%</strong> o engajamento 
                  em atividades de mudança comportamental, segundo meta-análise publicada 
                  no Journal of Medical Internet Research.
                </p>
                <p>
                  O suporte social de comunidades aumenta em <strong className="text-foreground">3x</strong> as 
                  chances de sucesso na manutenção de hábitos de longo prazo.
                </p>
              </div>
              
              <div className="mt-6 flex flex-wrap gap-2">
                <span className="text-xs bg-secondary px-3 py-1 rounded-full">Lally et al. (2010)</span>
                <span className="text-xs bg-secondary px-3 py-1 rounded-full">JMIR, 2019</span>
                <span className="text-xs bg-secondary px-3 py-1 rounded-full">American Psych. Association</span>
              </div>
            </div>
            
            <div className="grid grid-cols-2 gap-4">
              <div className="pond-card text-center">
                <div className="text-5xl mb-2">🥚</div>
                <h4 className="font-display font-bold">Dias 1-3</h4>
                <p className="text-sm text-muted-foreground">Ovo incubando</p>
              </div>
              <div className="pond-card text-center">
                <img src={tadpoleImage} alt="Girino" className="w-12 h-12 mx-auto mb-2 object-contain" />
                <h4 className="font-display font-bold">Dias 4-10</h4>
                <p className="text-sm text-muted-foreground">Girino nadando</p>
              </div>
              <div className="pond-card text-center">
                <img src={youngFrogImage} alt="Sapo Jovem" className="w-12 h-12 mx-auto mb-2 object-contain" />
                <h4 className="font-display font-bold">Dias 11-30</h4>
                <p className="text-sm text-muted-foreground">Sapo jovem</p>
              </div>
              <div className="pond-card text-center bg-gradient-to-br from-golden-light to-golden">
                <img src={frogImage} alt="Sapo Adulto" className="w-12 h-12 mx-auto mb-2 object-contain" />
                <h4 className="font-display font-bold text-foreground">Dia 31+</h4>
                <p className="text-sm text-foreground/80">Sapo adulto!</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Blog Section */}
      <section className="py-20 px-4 bg-secondary/30">
        <div className="container mx-auto">
          <div className="text-center mb-12">
            <h2 className="font-display text-3xl md:text-4xl font-bold text-foreground mb-4">
              Blog: Dicas para cultivar hábitos
            </h2>
          </div>
          
          <div className="grid lg:grid-cols-3 gap-6">
            {/* First two posts - horizontal */}
            <div className="lg:col-span-2 grid md:grid-cols-2 gap-6">
              <Link to="/blog/5-tecnicas-para-nunca-mais-procrastinar">
                <article className="pond-card group cursor-pointer hover:shadow-float transition-all h-full">
                  <div className="aspect-video rounded-2xl bg-pond-gradient mb-4 flex items-center justify-center text-5xl">
                    🎯
                  </div>
                  <span className="text-xs text-coral font-semibold uppercase">Produtividade</span>
                  <h3 className="font-display font-bold text-lg mt-1 mb-2 group-hover:text-primary transition-colors">
                    5 técnicas para nunca mais procrastinar
                  </h3>
                  <p className="text-sm text-muted-foreground">
                    Descubra métodos comprovados para vencer a procrastinação de uma vez por todas.
                  </p>
                </article>
              </Link>
              
              <Link to="/blog/como-a-meditacao-diaria-mudou-minha-vida">
                <article className="pond-card group cursor-pointer hover:shadow-float transition-all h-full">
                  <div className="aspect-video rounded-2xl bg-sunset-gradient mb-4 flex items-center justify-center text-5xl">
                    🧘
                  </div>
                  <span className="text-xs text-coral font-semibold uppercase">Bem-estar</span>
                  <h3 className="font-display font-bold text-lg mt-1 mb-2 group-hover:text-primary transition-colors">
                    Como a meditação diária mudou minha vida
                  </h3>
                  <p className="text-sm text-muted-foreground">
                    Um relato pessoal sobre os benefícios de meditar apenas 10 minutos por dia.
                  </p>
                </article>
              </Link>
            </div>
            
            {/* Three posts - vertical column */}
            <div className="flex flex-col justify-between h-full gap-4">
              {[{
              emoji: "💪",
              tag: "Fitness",
              title: "Como criar o hábito de exercícios",
              slug: "como-criar-o-habito-de-exercicios"
            }, {
              emoji: "📚",
              tag: "Aprendizado",
              title: "Leia 52 livros por ano",
              slug: "leia-52-livros-por-ano"
            }, {
              emoji: "💤",
              tag: "Sono",
              title: "Rotina noturna para dormir melhor",
              slug: "rotina-noturna-para-dormir-melhor"
            }].map((post, i) => <Link key={i} to={`/blog/${post.slug}`}>
                  <article className="pond-card group cursor-pointer hover:shadow-float transition-all flex items-center gap-4">
                    <div className="w-16 h-16 rounded-xl bg-secondary flex items-center justify-center text-2xl flex-shrink-0">
                      {post.emoji}
                    </div>
                    <div>
                      <span className="text-xs text-coral font-semibold uppercase">{post.tag}</span>
                      <h3 className="font-display font-bold text-sm group-hover:text-primary transition-colors">
                        {post.title}
                      </h3>
                    </div>
                  </article>
                </Link>)}
            </div>
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="py-24 px-4 relative overflow-hidden">
        <div className="absolute inset-0 bg-sunset-gradient opacity-10" />
        <div className="absolute top-10 right-10 text-6xl animate-float opacity-30">🐸</div>
        <div className="absolute bottom-10 left-10 text-4xl animate-float opacity-20" style={{
        animationDelay: "1.5s"
      }}>🪷</div>
        
        <div className="container mx-auto text-center relative z-10">
          <h2 className="font-display text-3xl md:text-5xl font-bold text-foreground mb-6">
            Pronto para transformar sua vida?
          </h2>
          <p className="text-lg text-muted-foreground max-w-xl mx-auto mb-8">
            Comece gratuitamente e só pague quando conseguir formar seu primeiro hábito. 
            Sem risco, só resultado.
          </p>
          <Button size="xl" variant="coral" asChild className="gap-2">
            <Link to="/auth">
              Criar conta grátis
              <ArrowRight className="w-5 h-5" />
            </Link>
          </Button>
        </div>
      </section>

      <Footer />
    </div>;
};
export default Home;